export default __webpack_public_path__ + "56bdf84751634e8deaff10d1d68df316.woff";